const Card = (props: Object) => (
  <div {...props} className="panel column-eq-height" />
);

export const CardBody = (props: Object) => (
  <div {...props} className="panel-body" />
);

export default Card;
